// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// @generated by protobuf-ts 2.9.6 with parameter force_server_none,optimize_code_size,ts_nocheck
// @generated from protobuf file "sui/rpc/v2/signature_verification_service.proto" (package "sui.rpc.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
//
import type { RpcTransport } from '@protobuf-ts/runtime-rpc';
import type { ServiceInfo } from '@protobuf-ts/runtime-rpc';
import { SignatureVerificationService } from './signature_verification_service.js';
import { stackIntercept } from '@protobuf-ts/runtime-rpc';
import type { VerifySignatureResponse } from './signature_verification_service.js';
import type { VerifySignatureRequest } from './signature_verification_service.js';
import type { UnaryCall } from '@protobuf-ts/runtime-rpc';
import type { RpcOptions } from '@protobuf-ts/runtime-rpc';
/**
 * @generated from protobuf service sui.rpc.v2.SignatureVerificationService
 */
export interface ISignatureVerificationServiceClient {
	/**
	 * Perform signature verification of a UserSignature against the provided message.
	 *
	 * @generated from protobuf rpc: VerifySignature(sui.rpc.v2.VerifySignatureRequest) returns (sui.rpc.v2.VerifySignatureResponse);
	 */
	verifySignature(
		input: VerifySignatureRequest,
		options?: RpcOptions,
	): UnaryCall<VerifySignatureRequest, VerifySignatureResponse>;
}
/**
 * @generated from protobuf service sui.rpc.v2.SignatureVerificationService
 */
export class SignatureVerificationServiceClient
	implements ISignatureVerificationServiceClient, ServiceInfo
{
	typeName = SignatureVerificationService.typeName;
	methods = SignatureVerificationService.methods;
	options = SignatureVerificationService.options;
	constructor(private readonly _transport: RpcTransport) {}
	/**
	 * Perform signature verification of a UserSignature against the provided message.
	 *
	 * @generated from protobuf rpc: VerifySignature(sui.rpc.v2.VerifySignatureRequest) returns (sui.rpc.v2.VerifySignatureResponse);
	 */
	verifySignature(
		input: VerifySignatureRequest,
		options?: RpcOptions,
	): UnaryCall<VerifySignatureRequest, VerifySignatureResponse> {
		const method = this.methods[0],
			opt = this._transport.mergeOptions(options);
		return stackIntercept<VerifySignatureRequest, VerifySignatureResponse>(
			'unary',
			this._transport,
			method,
			opt,
			input,
		);
	}
}
